namespace RioERP.Reports {
    export interface OrderShippingReportForm {
        OrderId: Serenity.StringEditor;
        OrderNumber: Serenity.StringEditor;
        OrderDate: Serenity.DateEditor;
        CustomerName: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        ProductSpecificationName: Serenity.StringEditor;
        SourceType: Serenity.IntegerEditor;
        BookStatus: Serenity.IntegerEditor;
    }

    export class OrderShippingReportForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.OrderShippingReport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderShippingReportForm.init)  {
                OrderShippingReportForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(OrderShippingReportForm, [
                    'OrderId', w0,
                    'OrderNumber', w0,
                    'OrderDate', w1,
                    'CustomerName', w0,
                    'ProductName', w0,
                    'ProductSpecificationName', w0,
                    'SourceType', w2,
                    'BookStatus', w2
                ]);
            }
        }
    }
}
